import { DOMParser } from 'prosemirror-model'
import LinkOrigin from 'tiptap-extensions/src/marks/Link'


const getHtml = (href, text, target, download) => (
  `<a href=${href} rel="noopener noreferrer nofollow" target="${target}" ${download ? (`download="${download}"`) : ''}>${text}</a>`
)

// from https://git.io/JtBEC
const insertLINK = (data) => (state, dispatch) => {
  const { selection } = state
  const {
    href, text, target, download,
  } = data

  const element = document.createElement('div')
  element.innerHTML = getHtml(href, text || href, target, download).trim()
  const slice = DOMParser.fromSchema(state.schema).parseSlice(element)
  const transaction = state.tr.insert(selection.anchor, slice.content)
  dispatch(transaction)
}

export class Link extends LinkOrigin {
  commands(...params) {
    const result = super.commands(...params)

    return typeof result === 'function'
      ? { link: result, insertLINK }
      : { ...result, insertLINK }
  }

  get schema() {
    return {
      attrs: {
        href: {
          default: null,
        },
        target: {
          default: '_blank',
        },
        download: {
          default: null,
        },
      },
      inclusive: false,
      parseDOM: [
        {
          tag: 'a[href]',
          getAttrs: (dom) => ({
            href: dom.getAttribute('href'),
            target: dom.getAttribute('target'),
            download: dom.getAttribute('download'),
          }),
        },
      ],
      toDOM: (node) => ['a', {
        ...node.attrs,
        rel: 'noopener noreferrer nofollow',
        target: node.attrs.target || this.options.target,
        download: node.attrs.download || this.options.download,
      }, 0],
    }
  }
}
